import api from "./api";

const atsService = {
  // Get all applications with filters
  getApplications: async (filters = {}) => {
    const queryParams = new URLSearchParams();

    Object.keys(filters).forEach((key) => {
      if (filters[key]) {
        queryParams.append(key, filters[key]);
      }
    });

    const response = await api.get(
      `/api/v1/ats/applications?${queryParams.toString()}`
    );
    return response;
  },

  // Get application by ID
  getApplicationById: async (id) => {
    const response = await api.get(`/api/v1/ats/applications/${id}`);
    return response;
  },

  // Update application status
  updateApplicationStatus: async (id, status, notes) => {
    const response = await api.put(`/api/v1/ats/applications/${id}/status`, {
      status,
      notes,
    });
    return response;
  },

  // Get candidates
  getCandidates: async (filters = {}) => {
    const queryParams = new URLSearchParams();

    Object.keys(filters).forEach((key) => {
      if (filters[key]) {
        queryParams.append(key, filters[key]);
      }
    });

    const response = await api.get(
      `/api/v1/ats/candidates?${queryParams.toString()}`
    );
    return response;
  },

  // Get candidate by ID
  getCandidateById: async (id) => {
    const response = await api.get(`/api/v1/ats/candidates/${id}`);
    return response;
  },

  // Get job requisitions
  getJobRequisitions: async (filters = {}) => {
    const queryParams = new URLSearchParams();

    Object.keys(filters).forEach((key) => {
      if (filters[key]) {
        queryParams.append(key, filters[key]);
      }
    });

    const response = await api.get(
      `/api/v1/job-requisitions?${queryParams.toString()}`
    );
    return response;
  },

  // Get job requisition by ID
  getJobRequisitionById: async (id) => {
    const response = await api.get(`/api/v1/job-requisitions/${id}`);
    return response;
  },

  // Create application
  createApplication: async (applicationData) => {
    const response = await api.post(
      "/api/v1/ats/applications",
      applicationData
    );
    return response;
  },

  // Update application
  updateApplication: async (id, updateData) => {
    const response = await api.put(
      `/api/v1/ats/applications/${id}`,
      updateData
    );
    return response;
  },

  // Get ATS statistics
  getATSStats: async () => {
    const response = await api.get("/api/v1/ats/stats");
    return response;
  },

  // Get pipeline data
  getPipelineData: async () => {
    const response = await api.get("/api/v1/ats/pipeline");
    return response;
  },
};

export default atsService;
